export default __webpack_public_path__ + "images/3453abbfc9ca0aba152dd0f00b8f19fa-powered_by_pharmaforce.svg";